import Make from './make'

const make = Make('setup/')

interface CreateClient {
  organisation: string
  email: string
  passW: string
  fName: string
  lName: string
  phoneNum?: string
  acceptedMarketing: boolean
}

export const createClient = async (data: CreateClient): Promise<any> => {
  const req = await make.post({
    endpoint: 'create-new-client',
    data: {
      ...data,
    },
  })

  if (!req.success && !(req.res.status === 403 || req.res.status === 400)) {
    return false
  }

  return req.res
}

interface CreateBillingUser {
  organisation: string
  email: string
  password: string
  fname: string
  lname: string
}

export const createBillingUser = async (
  data: CreateBillingUser,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'create-billing-account',
    data: {
      ...data,
      passW: data.password,
    },
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

interface ConnectFirstAccountFields {
  gaAccountID: string
  gaAccountName: string
  gaPropertyID: string
  gaPropertyName: string
  gaViewID: string
  gaViewName: string
  credentials: string
}

export const connectFirstAccount = async (
  data: ConnectFirstAccountFields,
): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'connect-first-account',
    data,
  })

  if (!req.success) {
    return false
  }

  return true
}

interface ContactUsForm {
  phone?: string
  email?: string
  message: string
  name?: string
}

export const contactUsForm = async (data: ContactUsForm): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'contact-us',
    data,
  })

  if (!req.success) {
    return false
  }

  return true
}
